/**
 * Js handle for Real Estate Settings
 */
import realpressCheckboxSortable from '../mixins/checkbox-sortable';
import realpressAdditionalFields from './mixins/additional-fields';
import realpressDropDownPage from './mixins/wp-dropdown-page';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressCheckboxSortable();
	realpressAdditionalFields();
	realpressDropDownPage();
} );
